import React from "react";

//interfaces and helpers
import { IContentImage } from "../../../../interfaces/image/image";

//components
import ProgressiveLoadingImage from "../ProgressiveLoadingImage";



const ContentImage = ({className, contentUrl, token, caption}: IContentImage) => {  
    return (
        <div className={`content-image-component ${className ?? ""}`}>
            <div className="content-image-wrapper">
                <img
                    className={`background-content-image-component`}
                    src={token ? `${contentUrl}?width=160&height=160&rmode=min&quality=50&access_token=${token}` : `${contentUrl}?width=160&height=160&rmode=min&quality=50`}
                    alt={""}
                />
                
                <ProgressiveLoadingImage 
                    lowResUrl={contentUrl} 
                    highResUrl={contentUrl} 
                    token={token}
                />
            </div>
            {caption && <span className="image-caption">{caption}</span>}
        </div>
    );
};

export default ContentImage;
